import ordersService from '../../services/orders'

const state = {
  orders: [],

}

// getters
const getters = {
  totalOrders: state => {
    if (state.orders != null) {
        return state.orders.length;
    }
    else {
        return 0;
    }
  },
  totalAmount : state => {
    if (state.orders != null) {
      let total = 0;
      state.orders.forEach(order => {
        order.orderDetails.forEach(detail => {
          total += detail.itemPrice * detail.quantity
        })
      });
      return total + ' kr';
    }
    else {
      return 0 + ' kr';
    }
  }
 
}

// actions
const actions = {
  async getOrdersByDateAction(context, date) {
    await ordersService.getOrdersByDateAndRestaurant(date)
                       .then(data => {
                          context.commit('setOrdersState', data);
                       });
  }
}

// mutations
const mutations = {
  setOrdersState(state, orders) {
    state.orders = orders;
  }
 
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}